import React, { useState,useEffect } from "react";

const Footer=()=>{
    return(<>
        <div>
   
            <p className="text-center py-3 mb-0" style={{ fontSize: "14px", opacity: 0.8 }}>
                <a className="footer-brand text-dark" target="_blank" href="https://www.vrsamadhantech.com/"
                style={{ textDecoration: "none"}}>
                    <span>Powered by :- VRSamadhan Tech Solution
                    </span>
                </a>
            </p>
        </div>
    </>)
}
export default Footer;